<template>
  <div class="ei-flex-tool-bar">
    <div class="content">
      <input type="checkbox"/>
      <span></span>
      <span></span>
      <ul>
        <li><a href="">点赞</a></li>
        <li><a href="">投币</a></li>
        <li><a href="">收藏</a></li>
        <li><a href="">关注</a></li>
        <li><a href="">分享</a></li>
      </ul>
    </div>
  </div>

</template>

<script>
export default {
  name: "EiFlexToolBar"
}
</script>

<style scoped lang="scss">
.ei-flex-tool-bar {
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 50px;
    background-color: #fff;

    input {
      width: 40px;
      height: 40px;
      opacity: 0;
      cursor: pointer;
      &:checked ~ ul {
        width: 350px;
      }

      &:checked ~ span:nth-child(2) {
        top: calc(50% - 2px);
        transform: rotate(-45deg);
        background-color: #FF8199;
        transition: top 0.3s ease-in-out, transform 0.3s ease-in-out 0.3s;
      }

      &:checked ~ span:nth-child(3) {
        top: calc(50% - 2px);
        transform: rotate(45deg);
        background-color: #FF8199;
        transition: top 0.3s ease-in-out, transform 0.3s ease-in-out 0.3s;
      }
    }

    span {
      position: absolute;
      left: 25px;
      top: calc(50% - 10px);
      width: 30px;
      height: 4px;
      border-radius: 15px;
      background-color: #999;
      pointer-events: none;
      transition: transform 0.3s ease-in-out, top 0.3s ease-in-out 0.3s;

      &:nth-child(3) {
        top: calc(50% + 6px);
      }
    }

    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 0;
      overflow: hidden;
      white-space: nowrap;
      transition: all .5s;

      li {
        margin: 0 15px;

        a {
          font-size: 20px;
          font-weight: 700;
          color: #333;

          &:hover {
            color: #FF8199;
          }
        }
      }
    }
  }
}
</style>
